import { useCallback } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';

import { useSessionData } from '@confluence/session-data';

import { analytics } from '../../experimentConstants';
import { useUserInfo } from '../../store/userInfoStore';

interface ButtonEventHandler extends Record<string, string | number | null | undefined> {
	actionSubjectId: string;
}

export const useButtonEventHandler = () => {
	const { daysLeftInTrial } = useUserInfo();
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const { edition } = useSessionData();

	const eventHandler = useCallback(
		({ actionSubjectId, ...args }: ButtonEventHandler) => {
			createAnalyticsEvent({
				type: 'sendUIEvent',
				data: {
					action: 'clicked',
					actionSubject: 'button',
					actionSubjectId,
					source: analytics.SOURCE,
					attributes: {
						edition,
						daysLeftInTrial,
						...args,
					},
				},
			}).fire();
		},
		[createAnalyticsEvent, daysLeftInTrial, edition],
	);

	return { eventHandler };
};
